import {
    Component,
    Inject,
    Input,
    OnDestroy,
    OnInit
} from '@angular/core';
import {Popup} from '../popup/Popup';
import {FeedbackPopupData} from './FeedbackPopupData';
import {FEEDBACK_RESOURCE_TOKEN, FeedbackService} from '../../services/FeedbackService';
import {FeedbackAllowRequestDto} from '../../services/rest/api-types/FeedbackAllowRequestDto';
import {Subscription} from 'rxjs';
import {FeedbackPopupService} from './feedback-popup.service';
import {NewFeedbackData} from './NewFeedbackData';

@Component({
    selector: 'mm-feedback',
    templateUrl: './feedback.component.html',
    styleUrls: ['./feedback.component.scss'],
    standalone: false
})
export class FeedbackComponent implements Popup<FeedbackPopupData>, OnInit, OnDestroy {
    @Input({required: true})
    public data!: FeedbackPopupData;

    @Input()
    public draftNewFeedbackData: NewFeedbackData | undefined;

    @Input()
    public allowReset: boolean = false;

    @Input({required: true})
    public checkIfFeedbackAllow!: boolean;

    private checkIfFeedbackPossibleSubscription = new Subscription();

    constructor(public feedbackPopupService: FeedbackPopupService,
                @Inject(FEEDBACK_RESOURCE_TOKEN) private feedbackResource: FeedbackService) {
    }

    public ngOnInit(): void {
        this.feedbackPopupService.showSpinner();
        const feedbackAllowRequestDto = new FeedbackAllowRequestDto(this.data.learningPackageId, this.data.questionId);
        this.checkIfFeedbackPossibleSubscription = this.feedbackResource.checkIfFeedbackAllow(feedbackAllowRequestDto).subscribe({
                next: () => {
                    this.feedbackPopupService.hideSpinner();
                    this.setFeedbackData();
                },
                error: () => {
                    this.feedbackPopupService.setNotAllow(true);
                    this.feedbackPopupService.hideSpinner();
                    this.feedbackPopupService.setFeedbackResultStep();
                }
            }
        );
    }

    private setFeedbackData(): void {
        if (this.draftNewFeedbackData !== undefined) {
            this.feedbackPopupService.setDraft(this.draftNewFeedbackData);
        } else {
            this.feedbackPopupService.setFeedbackIds(this.data.learningPackageId, this.data.questionId);
        }
    }

    public ngOnDestroy(): void {
        this.checkIfFeedbackPossibleSubscription.unsubscribe();
        this.feedbackPopupService.clearPopupStates();
    }
}
